import AddProduct from "./AddProduct"
import SellerNavbar from "../Navbar/Navbar_Seller"

export default function AddNewProduct() {
    return (
        <>
            <SellerNavbar />
            <>
            <br />
            <AddProduct  />
            </>
            <br />
            <br />
        </>
    )
}